// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_status__NNibC {
  color: #ffc107;
  font-size: 12px;
  font-weight: 500;
  margin: 0px;
  display: flex;
  padding: 4px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: var(--rs_yellow_10, #fff9e7);
  white-space: pre;
}

.style_new__sV11L {
  color: #757575;
  background: #f5f5f5;
}

.style_inProgress__z0BiR {
  color: #ffc107;
  background: #fff9e7;
}

.style_contacted__-OqSf {
  color: #220d77;
  background: #e9e7f2;
}

.style_hired__HL1s4 {
  color: #e6f6ec;
  background: #00a43b;
}

.style_rejected__RhIJX {
  color: #fff1ef;
  background: #d84315;
}

.style_spam__13IPb {
  color: #fff1ef;
  background: lightgray;
}

.style_TasksTable__t4Ljn,
.style_nameAndLogo__BOGQP {
  display: flex;
  align-items: center;
}
.style_TasksTable__t4Ljn p,
.style_nameAndLogo__BOGQP p {
  margin: 0;
}
.style_TasksTable__t4Ljn img,
.style_nameAndLogo__BOGQP img {
  margin-right: 10px;
  border-radius: 5px;
}
.style_TasksTable__t4Ljn .style_nameAndLogo__BOGQP p,
.style_TasksTable__t4Ljn .style_jobType__yuAr5 p,
.style_nameAndLogo__BOGQP .style_nameAndLogo__BOGQP p,
.style_nameAndLogo__BOGQP .style_jobType__yuAr5 p {
  margin: 0;
}
.style_TasksTable__t4Ljn .style_image-card__s27sd img,
.style_nameAndLogo__BOGQP .style_image-card__s27sd img {
  border-radius: 10px;
}
.style_TasksTable__t4Ljn .style_showFilesInvoice__ICLHx,
.style_nameAndLogo__BOGQP .style_showFilesInvoice__ICLHx {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5%;
}
.style_TasksTable__t4Ljn .style_fileCont__A-va8,
.style_nameAndLogo__BOGQP .style_fileCont__A-va8 {
  position: relative;
}
.style_TasksTable__t4Ljn .style_css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar__NzJDn,
.style_nameAndLogo__BOGQP .style_css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar__NzJDn {
  align-items: baseline;
}
.style_TasksTable__t4Ljn .style_statusOrders__rZzbv,
.style_nameAndLogo__BOGQP .style_statusOrders__rZzbv {
  display: flex;
  align-items: center;
}
.style_TasksTable__t4Ljn .style_statusOrders__rZzbv .style_space__KdwUr,
.style_nameAndLogo__BOGQP .style_statusOrders__rZzbv .style_space__KdwUr {
  margin-right: 5px;
}

.style_EnhancedTableToolbar__fgGI2 .style_sortAndFilters__wZaE2 {
  display: flex;
  justify-content: flex-end;
}

.style_filterDrawer__7yu-a .style_drawerContainer__erPlS {
  width: 20vw;
  min-width: 230px;
  margin-top: 60%;
}
.style_filterDrawer__7yu-a .style_drawerContainer__erPlS .style_header__Yjpa5 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.style_filterDrawer__7yu-a .style_drawerContainer__erPlS form > div {
  margin-top: 20px;
}
.style_filterDrawer__7yu-a .style_drawerContainer__erPlS .style_clearButt__4Y5Ho {
  margin-top: 20px;
  height: 3.5em;
}

@media (max-width: 768px) {
  * {
    font-size: 10px;
  }
}
.style_sortby__BZQ9S {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  width: fit-content;
  text-align: center;
  border-right: solid rgba(161, 158, 158, 0.5) 1px;
  border-left: solid rgba(161, 158, 158, 0.5) 1px;
}
.style_sortby__BZQ9S label {
  margin-right: 10px;
  margin-left: 10px;
}
.style_sortby__BZQ9S .style_css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root__nPk-h:before {
  border-bottom: none;
}
.style_sortby__BZQ9S #style_demo-simple-select__64xd0 {
  margin-top: 3px;
}

.style_removeIcon__1YFa- {
  cursor: pointer;
  transition: transform 0.2s;
}
.style_removeIcon__1YFa-:hover {
  transform: scale(1.2);
}
.style_removeIcon__1YFa-:active {
  transform: scale(0.9);
}

.style_css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root__bWhnD:before {
  border-bottom: none;
}

.style_searchBy__T52-J {
  border-left: none;
}`, "",{"version":3,"sources":["webpack://./src/views/AccountsAndPermissions/Accounts/InternalUsers/table/RowRender/style.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,wCAAA;EACA,gBAAA;AACF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAIA;EACE,cAAA;EACA,qBAAA;AADF;;AASA;;EAEE,aAAA;EACA,mBAAA;AANF;AAOE;;EACE,SAAA;AAJJ;AAME;;EACE,kBAAA;EACA,kBAAA;AAHJ;AAQI;;;;EACE,SAAA;AAHN;AAOE;;EACE,mBAAA;AAJJ;AAOE;;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAJJ;AAOE;;EACE,kBAAA;AAJJ;AAOE;;EACE,qBAAA;AAJJ;AAOE;;EACE,aAAA;EACA,mBAAA;AAJJ;AAKI;;EACE,iBAAA;AAFN;;AAQE;EACE,aAAA;EACA,yBAAA;AALJ;;AAUE;EAME,WAAA;EACA,gBAAA;EACA,eAAA;AAZJ;AAKI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAHN;AAQI;EACE,gBAAA;AANN;AAQI;EACE,gBAAA;EACA,aAAA;AANN;;AAWA;EACE;IACE,eAAA;EARF;AACF;AAUA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,eAAA;EACA,kBAAA;EACA,kBAAA;EAEA,gDA9FW;EA+FX,+CA/FW;AAqFb;AAYE;EACE,kBAAA;EACA,iBAAA;AAVJ;AAYE;EACE,mBAAA;AAVJ;AAYE;EACE,eAAA;AAVJ;;AAcA;EACE,eAAA;EACA,0BAAA;AAXF;AAYE;EACE,qBAAA;AAVJ;AAYE;EACE,qBAAA;AAVJ;;AAcA;EACE,mBAAA;AAXF;;AAaA;EACE,iBAAA;AAVF","sourcesContent":[".status {\n  color: #ffc107;\n  font-size: 12px;\n  font-weight: 500;\n  margin: 0px;\n  display: flex;\n  padding: 4px 8px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 100px;\n  background: var(--rs_yellow_10, #fff9e7);\n  white-space: pre;\n}\n\n.chanelChip {\n}\n\n.new {\n  color: #757575;\n  background: #f5f5f5;\n}\n\n.inProgress {\n  color: #ffc107;\n  background: #fff9e7;\n}\n\n.contacted {\n  color: #220d77;\n  background: #e9e7f2;\n}\n\n.hired {\n  color: #e6f6ec;\n  background: #00a43b;\n}\n\n.rejected {\n  color: #fff1ef;\n  background: #d84315;\n}\n.spam {\n  color: #fff1ef;\n  background: lightgray;\n}\n$borderSide: solid\n  rgba(\n    $color: #a19e9e,\n    $alpha: 0.5,\n  )\n  1px;\n.TasksTable,\n.nameAndLogo {\n  display: flex;\n  align-items: center;\n  p {\n    margin: 0;\n  }\n  img {\n    margin-right: 10px;\n    border-radius: 5px;\n  }\n\n  .nameAndLogo,\n  .jobType {\n    p {\n      margin: 0;\n    }\n  }\n\n  .image-card img {\n    border-radius: 10px;\n  }\n\n  .showFilesInvoice {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 5%;\n  }\n\n  .fileCont {\n    position: relative;\n  }\n\n  .css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar {\n    align-items: baseline;\n  }\n\n  .statusOrders {\n    display: flex;\n    align-items: center;\n    .space {\n      margin-right: 5px;\n    }\n  }\n}\n\n.EnhancedTableToolbar {\n  .sortAndFilters {\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n.filterDrawer {\n  .drawerContainer {\n    .header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n    width: 20vw;\n    min-width: 230px;\n    margin-top: 60%;\n    form > div {\n      margin-top: 20px;\n    }\n    .clearButt {\n      margin-top: 20px;\n      height: 3.5em;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  * {\n    font-size: 10px;\n  }\n}\n.sortby {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  margin-top: 5px;\n  width: fit-content;\n  text-align: center;\n\n  border-right: $borderSide;\n  border-left: $borderSide;\n\n  label {\n    margin-right: 10px;\n    margin-left: 10px;\n  }\n  .css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {\n    border-bottom: none;\n  }\n  #demo-simple-select {\n    margin-top: 3px;\n  }\n}\n\n.removeIcon {\n  cursor: pointer;\n  transition: transform 0.2s;\n  &:hover {\n    transform: scale(1.2);\n  }\n  &:active {\n    transform: scale(0.9);\n  }\n}\n\n.css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {\n  border-bottom: none;\n}\n.searchBy {\n  border-left: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status": `style_status__NNibC`,
	"new": `style_new__sV11L`,
	"inProgress": `style_inProgress__z0BiR`,
	"contacted": `style_contacted__-OqSf`,
	"hired": `style_hired__HL1s4`,
	"rejected": `style_rejected__RhIJX`,
	"spam": `style_spam__13IPb`,
	"TasksTable": `style_TasksTable__t4Ljn`,
	"nameAndLogo": `style_nameAndLogo__BOGQP`,
	"jobType": `style_jobType__yuAr5`,
	"image-card": `style_image-card__s27sd`,
	"showFilesInvoice": `style_showFilesInvoice__ICLHx`,
	"fileCont": `style_fileCont__A-va8`,
	"css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar": `style_css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar__NzJDn`,
	"statusOrders": `style_statusOrders__rZzbv`,
	"space": `style_space__KdwUr`,
	"EnhancedTableToolbar": `style_EnhancedTableToolbar__fgGI2`,
	"sortAndFilters": `style_sortAndFilters__wZaE2`,
	"filterDrawer": `style_filterDrawer__7yu-a`,
	"drawerContainer": `style_drawerContainer__erPlS`,
	"header": `style_header__Yjpa5`,
	"clearButt": `style_clearButt__4Y5Ho`,
	"sortby": `style_sortby__BZQ9S`,
	"css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root": `style_css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root__nPk-h`,
	"demo-simple-select": `style_demo-simple-select__64xd0`,
	"removeIcon": `style_removeIcon__1YFa-`,
	"css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root": `style_css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root__bWhnD`,
	"searchBy": `style_searchBy__T52-J`
};
export default ___CSS_LOADER_EXPORT___;
